import { DialogActions, DialogContent } from '@material-ui/core';
import React from 'react';
import { Button } from '../common/Button';
import { DialogTitle } from '../common/Dialog';
import { CloseIconButton } from '../common/IconButton';
import { Typography } from '../common/Typography';

export interface LeaveGalleryEditorModalProps {
  onClose: () => void;
  onLeave: () => void;
  onSave: () => void;
  onContinue: () => void;
  saveEnabled: boolean;
}

export const LeaveGalleryEditorModal: React.FC<LeaveGalleryEditorModalProps> = ({
  onClose,
  onLeave,
  onSave,
  onContinue,
  saveEnabled,
}) => (
  <>
    <DialogTitle>Leave Gallery Creation?</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to leave the edit window of your gallery? All unsaved changes will be
        lost.
      </Typography>
    </DialogContent>
    <DialogActions style={{ whiteSpace: 'nowrap', padding: 16 }}>
      {saveEnabled && <Button onClick={onSave}>Save & Leave</Button>}
      <Button variant='outlined' onClick={onLeave}>
        Leave Without Saving
      </Button>
      <Button variant='outlined' onClick={onContinue}>
        Continue Editing
      </Button>
      <CloseIconButton onClick={onClose} />
    </DialogActions>
  </>
);
